
import { get, post } from '@Lib/request'
import { path } from "./url";

const { usedCarApiV4, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV1 } = path;

export async function getCampaignsComment(params: { type: string }) {
  return await get<any>(`${newCarApiV3}/campaigns/comments`, params)
}

export async function upDateCampaignsComment(params: { type: string; content: string }) {
  return await post<any>(`${newCarApiV3}/campaigns/comment`, params)
}

export async function getEventCollectList(params: { limit: number }) {
  return await get<any>(`${newCarApiV3}/freeTrial/article/event/collect/list`, params)
}